import React from 'react';
import { Chip } from '@mui/material';
import type { InventoryStatus } from '../types/inventory';

const STATUS_SX: Record<InventoryStatus, { bgcolor: string; color: string }> = {
  Activo: { bgcolor: 'rgba(34, 197, 94, 0.12)', color: 'rgb(21, 128, 61)' },
  Vendido: { bgcolor: 'rgba(59, 130, 246, 0.12)', color: 'rgb(29, 78, 216)' },
  Inactivo: { bgcolor: 'rgba(239, 68, 68, 0.12)', color: 'rgb(185, 28, 28)' },
  Incompleto: { bgcolor: 'rgba(148, 163, 184, 0.2)', color: 'rgb(71, 85, 105)' },
  Devuelto: { bgcolor: 'rgba(245, 158, 11, 0.18)', color: 'rgb(180, 83, 9)' },
  'Devolución pendiente': { bgcolor: 'rgba(168, 85, 247, 0.14)', color: 'rgb(107, 33, 168)' },
  'Recogida pendiente': { bgcolor: 'rgba(14, 165, 233, 0.14)', color: 'rgb(3, 105, 161)' },
};

function InventoryStatusChip({ status }: { status: InventoryStatus }): React.ReactElement {
  const sx = STATUS_SX[status];
  const isLongLabel = status === 'Devolución pendiente' || status === 'Recogida pendiente';
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        height: isLongLabel ? 'auto' : 22,
        minHeight: 22,
        fontSize: isLongLabel ? '0.6875rem' : '0.75rem',
        fontWeight: 600,
        bgcolor: sx.bgcolor,
        color: sx.color,
        borderRadius: '9999px',
        maxWidth: 200,
        '& .MuiChip-label': {
          px: 1,
          py: isLongLabel ? 0.25 : 0,
          whiteSpace: isLongLabel ? 'normal' : 'nowrap',
          lineHeight: 1.25,
          textAlign: 'center',
        },
      }}
    />
  );
}

export default InventoryStatusChip;
